import React from 'react';
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import { FaTimes } from 'react-icons/fa';

import Filter from '../../filter/FilterPannel';

class ConditionText extends React.Component {

  onConditionChanged = condition => {
    let filter = { ...this.props.filter };
    filter = { ...filter, condition, andor: false };
    this.props.onFilterChanged(this.props.index, filter);
  }

  onTextChanged = value => {
    let filter = { ...this.props.filter };
    filter = { ...filter, value };
    this.props.onFilterChanged(this.props.index, filter);
  }

  render() {
    const i = this.props.index;
    const filter = this.props.filter;
    return (
      <div key={`condition_${i}`} className="col-md-12 condition-select-div">
        {filter.field.label}
        
        <div className="condition-select col-md-3">
          <Select value={filter.condition} 
            onChange={ selected => this.onConditionChanged(selected) }
            options={filter.conditions} isSearchable={true} isClearable={true} />
        </div>

        <div className="condition-select col-md-3 value-float">
        { filter.condition && filter.condition.value !== Filter.Empty && filter.condition.value !== Filter.NotEmpty
          ? <FormControl type="text" placeholder="Value" value={filter.value}
            onChange={ event => this.onTextChanged(event.target.value) } />
          : null
        }

          { false && (filter.isSelect || filter.isCity || filter.isState || filter.isCountry)
            && filter.select && filter.select.length > 1
            ? <div>
                <label>Inner Condition</label>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={filter.andor}
                    onChange={() => this.onCondition(i, true)} />
                  <Form.Check.Label>AND</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={!filter.andor}
                    onChange={() => this.onCondition(i, false)} />
                  <Form.Check.Label>OR</Form.Check.Label>
                </Form.Check>
              </div>
            : null
          }

          <Button variant="danger" onClick={() => this.props.onDelete(i)}><FaTimes /></Button>
        </div>
      </div>
    );
  }
}
export default ConditionText;